import ReactGA from 'react-ga4';

let isInitialized = false;

export const initializeAnalytics = () => {
  if (isInitialized) {
    return;
  }

  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Google Analytics measurement ID is missing');
    }
    return;
  }

  ReactGA.initialize(measurementId);
  isInitialized = true;
};

export const trackPageView = (path) => {
  if (!isInitialized) {
    return;
  }

  ReactGA.send({ hitType: 'pageview', page: path });
};
